import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import { useState } from "react";
import Banner from "../components/Banner";
import BreadcrumbBar from "../components/Breadcrumb";
import PricingCard from "../components/PricingCard";

export default function Pricing() {
  const tabOptions = [
    { key: "monthly", label: "Monthly", priceField: "price_monthly" },
    {
      key: "annually",
      label: "Annually",
      priceField: "price_annually",
      extraLabel: "Save 20%",
    },
  ];
  const items = [
    {
      id: 1,
      title: "Research Explorer",
      price_monthly: 0,
      price_annually: 0,
      description:
        "Decision-making in healthcare relies on understanding patients",
      btnLabel: "Start Free",
      type: "monthly",
      popular: false,
      features: {
        description: "Users exploring limited content",
        options: [
          "Limited AI Research Summaries",
          "Basic Personalized Feed",
          "Saved Articles Up to 5",
          "Alerts & Notifications",
        ],
      },
    },
    {
      id: 2,
      title: "Insight Plus",
      price_monthly: 30,
      price_annually: 288,
      description: "Premium subscribers unlocking advanced features.",
      btnLabel: "Upgrade to Plus",
      type: "monthly",
      popular: true,
      features: {
        description: "Subscribers who want deeper insights and personalization",
        options: [
          "Limited AI Research Summaries",
          "Basic Personalized Feed",
          "Saved Articles Up to 5",
          "Alerts & Notifications",
        ],
      },
    },
    {
      id: 3,
      title: "Knowledge Pro",
      price_monthly: 90,
      price_annually: 864,
      description: "Subscribers with full access and exclusive perks.",
      btnLabel: "Go Pro – Best Value",
      type: "monthly",
      popular: false,
      features: {
        description: "Power users who want full access and exclusive perks",
        options: [
          "Limited AI Research Summaries",
          "Basic Personalized Feed",
          "Saved Articles Up to 5",
          "Alerts & Notifications",
        ],
      },
    },
  ];

  const [pricingCard, setPricingCard] = useState(items);
  const [activeTab, setActiveTab] = useState("monthly");

  return (
    <>
      <Banner
        heading="Looking for best Article?"
        description="Type a disease, keyword, or question and explore easy-to-read research summaries made just for you."
      />
      <BreadcrumbBar
        items={[{ label: "Home", href: "/" }, { label: "Pricing" }]}
      />
      <Container>
        <div className="pricing">
          <Row className="mb-3 align-items-center">
            <Col className="text-center">
              <div className="heading">
                <h2>Select a Plan to Get Started</h2>
                <p>
                  Compare features and choose the option that matches your
                  research needs.
                </p>
              </div>
              <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="justify-content-center"
                variant="pills"
              >
                {tabOptions.map((tab) => (
                  <Tab
                    eventKey={tab.key}
                    title={
                      <>
                        {tab.label}{" "}
                        {tab.extraLabel && (
                          <span className="external-label ms-1">
                            {tab.extraLabel}
                          </span>
                        )}
                      </>
                    }
                    key={tab.key}
                  >
                    <Row className="align-items-end gx-4">
                      {pricingCard.map((item, index) => (
                        <Col md={12} lg={4} key={index}>
                          <PricingCard props={item} activeTab={activeTab} />
                        </Col>
                      ))}
                    </Row>
                  </Tab>
                ))}
              </Tabs>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}
